  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyAXyKK3tHVeYYxVk8y_6P9eYMJmC-YVrGk",
  authDomain: "zhanglutvando.firebaseapp.com",
  projectId: "zhanglutvando",
  storageBucket: "zhanglutvando.firebasestorage.app",
  messagingSenderId: "2744128558",
  appId: "1:2744128558:web:fd434f38fad65804077bbf",
  measurementId: "G-C6SCYMTK3B"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
